import { Search } from '@/DTOS/PmOffer/Search';
import request from '../../utils/request';

const PmOfferService = {
  search: (search: Search) => {
    return request('/pmOffer/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchComment: (search: Search) => {
    return request('/pmOffer/searchComment', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    formData: {
      accountSaleId: any;
      projectAuthorId: any;
      companyId: any;
      enumPmOfferStatusId: any;
      enumPmOfferContractTypeId: any;
      date: any;
      dateStart?: any;
      dateEnd?: any;
      remarks: any;
      costPerKilometer: any;
      pmOfferIntervals: any;
      pmOfferWorkPlaceItems: any;
      pmOfferLaborExtras: any;
      pmOfferComments?: any;
      pmOfferSectionFiles?: any;
    }
  ) => {
    return request('/pmOffer/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          accountSaleId: formData.accountSaleId,
          projectAuthorId: formData.projectAuthorId,
          companyId: formData.companyId,
          enumPmOfferStatusId: formData?.enumPmOfferStatusId,
          enumPmOfferContractTypeId: formData?.enumPmOfferContractTypeId,
          date: formData.date,
          dateStart: formData.dateStart,
          dateEnd: formData.dateEnd,
          remarks: formData.remarks,
          pmOfferIntervals: formData?.pmOfferIntervals,
          pmOfferWorkPlaceItems: formData?.pmOfferWorkPlaceItems,
          pmOfferLaborExtras: formData?.pmOfferLaborExtras,
          pmOfferComments: formData?.pmOfferComments,
          pmOfferSectionFiles: formData?.pmOfferSectionFiles,
          costPerKilometer: formData?.costPerKilometer,
        },
      }),
    });
  },

  upload: (/** @type {any} */ file: any) => {
    return request(
      '/pmOffer/uploadFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: file,
      },
      true
    );
  },

  preview: (
    id: any,
    formData: {
      projectAuthorId: any;
      accountSaleId: any;
      projectAuthor: any;
      accountSale: any;
      companyId: any;
      enumPmOfferStatusId: any;
      enumPmOfferContractTypeId: any;
      number: any;
      date: any;
      dateStart?: any;
      dateEnd?: any;
      remarks: any;
      company: any;
      enumPmOfferStatus: any;
      pmOfferIntervals: any;
      pmOfferWorkPlaceItems: any;
      pmOfferLaborExtras: any;
    }
  ) => {
    return request(
      '/pmOffer/preview',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          request: {
            id: id,
            accountSaleId: formData.accountSaleId,
            projectAuthorId: formData.projectAuthorId,
            companyId: formData.companyId,
            enumPmOfferStatusId: formData.enumPmOfferStatusId,
            enumPmOfferContractTypeId: formData.enumPmOfferContractTypeId,
            number: formData.number,
            date: formData.date,
            dateStart: formData.dateStart,
            dateEnd: formData.dateEnd,
            remarks: formData.remarks,
            accountSale: formData.accountSale,
            projectAuthor: formData.projectAuthor,
            company: formData.company,
            enumPmOfferStatus: formData.enumPmOfferStatus,
            pmOfferIntervals: formData.pmOfferIntervals,
            pmOfferWorkPlaceItems: formData.pmOfferWorkPlaceItems,
            pmOfferLaborExtras: formData.pmOfferLaborExtras,
          },
        }),
      },
      true
    );
  },

  clone: (clone: string) => {
    return request('/pmOffer/clone', {
      method: 'POST',
      body: JSON.stringify({ request: clone }),
    });
  },

  print: (search: Search) => {
    return request(
      '/pmOffer/print',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: { ...search } }),
      },
      true
    );
  },

  downloadSectionFile: (/** @type {any} */ id: any) => {
    return request(
      '/pmOffer/downloadSectionFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: id }),
      },
      true
    );
  },

  downloadFile: (/** @type {any} */ formData: any) => {
    return request(
      '/pmOffer/downloadFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: formData,
      },
      true
    );
  },
};

export default PmOfferService;
